import { TYPES } from "./types";
import { tkt1EtsyInfoPackService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1EtsyInfoPacks = (query) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.getEtsyInfoPacks(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACKS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACKS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1EtsyInfoPackByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.getEtsyInfoPackByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1EtsyInfoPackByMID = (mid) => async (dispatch) => {
  try {
    console.log('Action: getTKT1EtsyInfoPackByMID called with MID:', mid);
    const result = await tkt1EtsyInfoPackService.getEtsyInfoPackByMID(mid);
    console.log('Action: API result:', result);
    const data = result.data.data;
    console.log('Action: Extracted data:', data);
    
    if (data) {
      console.log('Action: Dispatching SUCCESS with data:', data);
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      console.log('Action: No data found, dispatching FAIL');
      dispatch({
        type: TYPES.ACTION_GET_TKT1_ETSY_INFO_PACK_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    console.error('Action: Error in getTKT1EtsyInfoPackByMID:', error);
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1EtsyInfoPacks = (query) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.searchEtsyInfoPacks(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_ETSY_INFO_PACKS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1EtsyInfoPack = (etsyInfoPackData) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.createEtsyInfoPack(etsyInfoPackData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_ETSY_INFO_PACK_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_ETSY_INFO_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1EtsyInfoPack = (id, etsyInfoPackData) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.updateEtsyInfoPack(id, etsyInfoPackData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_ETSY_INFO_PACK_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_ETSY_INFO_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1EtsyInfoPack = (id) => async (dispatch) => {
  try {
    const result = await tkt1EtsyInfoPackService.deleteEtsyInfoPack(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_ETSY_INFO_PACK_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_ETSY_INFO_PACK_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1EtsyInfoPackAction = {
  getTKT1EtsyInfoPacks,
  getTKT1EtsyInfoPackByID,
  searchTKT1EtsyInfoPacks,
  createTKT1EtsyInfoPack,
  updateTKT1EtsyInfoPack,
  deleteTKT1EtsyInfoPack
};
